
import i18n from 'i18next'
import XHR from 'i18next-xhr-backend'
import { reactI18nextModule } from 'react-i18next'


const translationURL =
  `${process.env.REACT_APP_BASE_API_URL}/translations/%lng%`

/*
    This is merely a way to handle a horrible situation. The ColdFusion
    Api is coercing 'Yes' and 'No' into boolean true and false
    respectively and serializing at the api level is too troublesome.
    Thus react is trying to interpolate boolean values and the result is
    empty. Outside of english and spanish, the problem is muted since
    'Yes' and 'No' are not the translated values. This processor returns
    'Yes' / 'No' depending on the key and language. See demographics section
    for example.
 */
const yesOrNoPostProcessor = {
    type: 'postProcessor',
    name: 'yesOrNo',
    process(value, key, options, translator) {
        const {language} = translator
        if(language === 'en') {
            return key
        } else if(language === 'es') {
            return key === false ? 'No' : value
        }
        return value
    }
}

i18n
  .use(XHR)
  .use(reactI18nextModule)
  .use(yesOrNoPostProcessor)
  .init({
    backend: {
      crossDomain: true,
      loadPath: translationURL
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // react takes care of this
      prefix: '%',
      suffix: '%',
      format(value, format) {
          if(format === 'EMAIL') {
              return `<a class="email" href="mailto:${value}">${value}</a>`
          }
          return value
      },
    },
    lng: sessionStorage.getItem('lang') || 'en',
    react: {
      // bindStore is tbd
      // bindStore: ''
      wait: true
    }
  })

export default i18n



// WEBPACK FOOTER //
// ./src/i18n.js